export default function(map) {
  var keys = [];
  for (var key in map) keys.push(key);
  return keys;
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-collection/src/keys.js
// module id = JFX9
// module chunks = 0